import { base64ToBytesArray } from '../../utils/file';
import { createClickDownload as createClickDownloadLink } from '../../utils/dom';

/**
 *
 *
 * @param {File} fileObj
 * @param { function(object, ArrayBuffer):void } cb - callback function that gets called when file is loaded
 *
 */
function handleFileLoad(fileObj, cb) {
    const reader = new FileReader();

    reader.onload = (function (file) {
        return function (evt) {
            const loadedFileBuffer = evt.target.result;

            const extensionSplit = file.name.split('.');
            const extension = extensionSplit[extensionSplit.length - 1];
            let name = file.name.replace(extension, '');
            name = name.substring(0, name.length - 1);

            const loadedFile = {
                fullName: file.name,
                path: 'unavailable-in-web',
                length: loadedFileBuffer.byteLength,
                size: file.size,
                name,
                extension,
            };

            cb(loadedFile, loadedFileBuffer);
        };
    })(fileObj);

    reader.readAsArrayBuffer(fileObj);
}

/**
 *
 * Save the given file, resolves with an object in the structure expected by fg-file-browser
 *
 * @returns {Promise<object>}
 */
function saveFile({ name, data }) {
    return new Promise((resolve) => {
        try {
            const blob = makeFileBlob(data);
            createClickDownloadLink(name, blob);

            resolve({
                status: true,
                message: '', // expects empty string if success
            });
        } catch (err) {
            // if anything throws, resolves with a status of false
            resolve({
                status: false,
                message: err.message,
            });
        }
    });
}

/**
 *
 * Convert base64 encoded file to file Blob
 *
 * @param {string} base64
 * @return {Blob}
 *
 */
function makeFileBlob(base64) {
    const bytesArray = base64ToBytesArray(base64);
    return new Blob([bytesArray], {
        type: 'application/octet-stream',
    });
}

/**
 *
 * @param {File[]} files
 * @param { function(object, ArrayBuffer):void } cb - callback function that gets called when each file is loaded
 *
 */
function handleSelectedFiles(files, cb) {
    // call the callback for each file (in the case multi select)
    files.forEach((file) => {
        handleFileLoad(file, cb);
    });
}

export { handleFileLoad, handleSelectedFiles, saveFile };
